import request from './request'

export function listSkill(data) {
  return request.post('/mes/skills/list', data)
}
export function selectSkill() {
  return request.get('/mes/skills/select')
}
export function getSkill(id) {
  return request.get('/mes/skills/' + id)
}
export function saveSkill(data) {
  return request.post('/mes/skills', data)
}
export function updateSkill(data) {
  return request.post('/mes/skills/update', data)
}
export function deleteSkill(ids) {
  return request.post('/mes/skills/delete', ids)
}
